












































import Vue from "vue";
import Util from "./../../lib/util";
import Modal from "../../components/common/confirm.js";

export default Vue.extend({
  name: "defined-grade-selector",
  props: ["currentGradeModel"],
  data() {
    return {
      visible: false,
      commonList: [],
      myList: [],
      predefinedGradeName: "",
    };
  },
  computed: {
    enableSaveList(): any {
      var list = this.commonList.concat(this.myList);
      return this.currentGradeModel && this.currentGradeModel.length > 0 && list.filter((item) => JSON.stringify(item.grades) === JSON.stringify(this.currentGradeModel)).length === 0;
    },
  },
  mounted() {
    let abp = Util.abp;
    this.commonList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.CommonGradeList"]) : [];
    this.myList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyGradeList"]) : [];

    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  methods: {
    handleClick(item) {
      this.visible = false;
      this.$emit("on-select", item);
    },
    handleRemove(item) {
      for (var i = 0; i < this.myList.length; i++) {
        if (this.myList[i] === item) {
          this.myList.splice(i, 1);
        }
      }

      this.changeMyGradeList();
    },
    changeMyGradeList() {
      this.$store.dispatch("goal/changeMyGradeList", { model: JSON.stringify(this.myList) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyRoleList"] = JSON.stringify(this.myList);
        }

        this.$Notice.success({
          title: "Save",
          desc: "My scale list updated!",
        });
      });
    },
    handleSaveToPredefined() {
      let context = this;
      context.predefinedGradeName = "";
      context.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h("Input", {
              props: {
                value: context.predefinedGradeName,
                autofocus: true,
                placeholder: "Please enter scale name...",
              },
              on: {
                input: (val) => {
                  context.predefinedGradeName = val;
                },
              },
            }),
          ]);
        },
        onOk: async () => {
          let id = 0;
          context.myList.forEach((item) => {
            if (item.value > id) {
              id = item.value;
            }
          });
          id = id + 1;
          context.myList.push({ value: id, label: context.predefinedGradeName, grades: JSON.parse(JSON.stringify(context.currentGradeModel)) });

          context.changeMyGradeList();
        },
      });
    },
  },
});
